import { BookOpen, ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CustomText from "components/Atoms/CustomText/CustomText";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { OPEN_GOVERNMENT_RESOURCES_URL } from "config/ExternalLinksConfig";
import { COLORS } from "constants/variables";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";
import { ResourceAction, ResourceBanner, ResourceCopy, ResourceSource } from "./OpenGovernmentBannerStyled";

const OpenGovernmentBanner = () => {
  const { t } = useTranslation();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const label = (key: string) => t(`view.homePage.openGovernment.${key}`);

  return (
    <ResourceBanner href={OPEN_GOVERNMENT_RESOURCES_URL} target="_blank" rel="noopener noreferrer"
      $biggerCursor={biggerCursor} aria-labelledby="open-government-title" aria-describedby="open-government-new-tab">
      <ResourceCopy>
        <ResourceSource>
          <BookOpen size={24} aria-hidden="true" />
          <CustomText text={label("source")} type={TextType.P2} color={COLORS.Yellow} />
        </ResourceSource>
        <div id="open-government-title" role="heading" aria-level={2}>
          <CustomText text={label("title")} type={TextType.H3} color={COLORS.Cultured} />
        </div>
        <CustomText text={label("description")} type={TextType.P1} color={COLORS.Cultured} />
      </ResourceCopy>
      <ResourceAction>
        {label("button")}<ExternalLink size={16} aria-hidden="true" />
      </ResourceAction>
      <span id="open-government-new-tab" hidden>{label("newTab")}</span>
    </ResourceBanner>
  );
};

export default OpenGovernmentBanner;
